import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import styles from './CommentCard.module.sass'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'
import { useReload } from 'store'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

const CommentCardActions = (props) => {
	const { data, flipped, ...attributes } = props
	const { showDialog, i18n } = useGlobal()
	const reload = useReload()

	const options = [
		[
			{
				value: 'comment',
				text: i18n`Reply`,
				action: () => {
					showDialog(
						'CommentDialog',
						i18n`Reply to comment`,
						{
							processId: data.processId,
							commentId: `${data?.id}`,
						},
						false,
						undefined,
						'center',
						'comment-dialog'
					)
						.then(() => {
							reload([])
						})
						.catch(() => null)
				},
			},
		],
	]

	const titles = [i18n`Actions`]

	return (
		<span
			{...attributes}
			className={`${styles['card-actions']} ${
				flipped ? styles['--flipped'] : ''
			}`}
		>
			<VStack className={styles['actions-content']}>
				<ModalOptions
					className={styles['actions-modal']}
					titles={titles}
					groups={options}
					options={options}
					corner='straight'
					onSelect={(item) => {
						item && item.action && item.action()
					}}
				>
					<button className={styles['comment-options']}>
						<Icon width='20px' height='20px' name={'options'} />
					</button>
				</ModalOptions>
			</VStack>
		</span>
	)
}

export default CommentCardActions
